import React from 'react';
import { motion } from 'framer-motion';
import { Star, MessageCircle, Phone, Award } from 'lucide-react';

const DriverCard = ({ driver, onSelect = () => {}, index = 0 }) => {
  return (
    <motion.div
      className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-all duration-300 cursor-pointer group"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      whileHover={{ y: -3 }}
      onClick={() => onSelect(driver)}
    >
      <div className="flex items-start gap-4">
        <div className="relative">
          <img 
            src={driver.photo} 
            alt={driver.name}
            className="w-16 h-16 rounded-full object-cover border-3 border-green-200"
          />
          <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
            <Award className="w-3 h-3 text-white" />
          </div>
        </div>

        <div className="flex-1">
          <div className="flex items-center justify-between mb-2">
            <h4 className="text-lg font-bold text-gray-800 group-hover:text-green-600 transition-colors">
              {driver.name}
            </h4>
            <div className="flex items-center gap-1 bg-yellow-50 px-2 py-1 rounded-full">
              <Star className="w-4 h-4 text-yellow-500 fill-current" />
              <span className="text-sm font-bold text-gray-800">{driver.rating}</span>
            </div>
          </div>

          <div className="space-y-2 mb-4">
            <p className="text-sm text-gray-600">
              <span className="font-semibold">Experiencia:</span> {driver.experience}
            </p>
            <p className="text-sm text-gray-600">
              <span className="font-semibold">Vehículo:</span> {driver.vehicle}
            </p>
            <p className="text-sm text-gray-600">
              <span className="font-semibold">Idiomas:</span> {driver.languages.join(', ')}
            </p>
            <p className="text-sm text-gray-600">
              <span className="font-semibold">Viajes:</span> {driver.totalTrips.toLocaleString()}
            </p>
          </div>

          <div className="flex flex-wrap gap-2 mb-4">
            {driver.specialties.map((specialty, idx) => (
              <span 
                key={idx}
                className="px-2 py-1 bg-blue-100 text-blue-700 text-xs rounded-full font-medium"
              >
                {specialty}
              </span>
            ))}
          </div>

          <div className="flex gap-2">
            <motion.button
              className="flex-1 bg-gradient-to-r from-green-500 to-blue-500 text-white py-2 px-4 rounded-xl font-semibold text-sm hover:shadow-lg transition-all"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              Seleccionar
            </motion.button>
            
            <motion.button
              className="p-2 bg-gray-100 hover:bg-gray-200 rounded-xl transition-colors"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              <MessageCircle className="w-4 h-4 text-gray-600" />
            </motion.button>
            
            <motion.button
              className="p-2 bg-gray-100 hover:bg-gray-200 rounded-xl transition-colors"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              <Phone className="w-4 h-4 text-gray-600" />
            </motion.button>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default DriverCard;